(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    /*
    Sticky pinning for the filter / sort bars.
    Elements opt in with the [data-facets-sticky] attribute (see the Liquid above).
  */
  (() => {
    if (window.__facetsStickyBound) return;
    window.__facetsStickyBound = true;

    const SELECTOR = '[data-facets-sticky]';
    const PINNED = 'facets-is-pinned';
    const SPACER = 'facets-sticky-spacer';
    const root = document.documentElement;
    let queued = false;

    // Space taken by a sticky header. Override with --facets-sticky-offset if needed.
    const getOffset = () => {
      const styles = getComputedStyle(document.documentElement);
      const values = ['--facets-sticky-offset', '--header-group-height', '--header-height'].map((name) =>
        parseFloat(styles.getPropertyValue(name))
      );
      return values.find((value) => Number.isFinite(value)) || 0;
    };

    const getSpacer = (el) => {
      const prev = el.previousElementSibling;
      return prev && prev.classList.contains(SPACER) ? prev : null;
    };

    const unpin = (el, spacer) => {
      el.classList.remove(PINNED);
      el.style.removeProperty('top');
      el.style.removeProperty('left');
      el.style.removeProperty('width');
      if (spacer) spacer.remove();
    };

    const update = () => {
      queued = false;
      const offset = getOffset();
      let pinnedHeight = 0;

      document.querySelectorAll(SELECTOR).forEach((el) => {
        const isPinned = el.classList.contains(PINNED);
        let spacer = getSpacer(el);

        // Clean up leftovers, e.g. after a filter re-render replaced the element's attributes.
        if (spacer && !isPinned) {
          spacer.remove();
          spacer = null;
        }

        // Pinned but hidden at this breakpoint (or spacer lost): release it.
        if (isPinned && (!spacer || !el.offsetHeight)) {
          unpin(el, spacer);
          return;
        }

        if (!isPinned) {
          const rect = el.getBoundingClientRect();

          // Hidden at this breakpoint, or still below the pin line.
          if (!rect.height || rect.top > offset) return;

          // Already scrolled past the whole section: nothing to pin.
          const section = el.closest('.shopify-section');
          if (section && section.getBoundingClientRect().bottom < offset + rect.height) return;

          const cs = getComputedStyle(el);
          const mt = parseFloat(cs.marginTop) || 0;
          const mb = parseFloat(cs.marginBottom) || 0;

          spacer = document.createElement('div');
          spacer.className = SPACER;
          spacer.style.cssText = `grid-column:${cs.gridColumn};height:${rect.height + mt + mb}px;margin:0;`;
          spacer.dataset.mt = mt;
          spacer.dataset.ml = parseFloat(cs.marginLeft) || 0;
          spacer.dataset.mr = parseFloat(cs.marginRight) || 0;

          el.before(spacer);
          el.classList.add(PINNED);
        }

        const spacerRect = spacer.getBoundingClientRect();
        const mt = Number(spacer.dataset.mt) || 0;
        const ml = Number(spacer.dataset.ml) || 0;
        const mr = Number(spacer.dataset.mr) || 0;

        // Scrolled back up past the original position: return to normal flow.
        if (spacerRect.top + mt > offset + 0.5) {
          unpin(el, spacer);
          return;
        }

        // Push the bar up and out as the end of the section scrolls into view.
        const height = el.offsetHeight;
        const section = el.closest('.shopify-section');
        const limit = section ? section.getBoundingClientRect().bottom - height : offset;

        el.style.top = `${Math.min(offset, limit)}px`;
        el.style.left = `${spacerRect.left + ml}px`;
        el.style.width = `${spacerRect.width - ml - mr}px`;

        pinnedHeight += height;
      });

      // Lets the sticky sidebar sit underneath a pinned top bar.
      root.style.setProperty('--facets-pinned-height', `${pinnedHeight}px`);
    };

    const request = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(update);
    };

    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request);
    window.addEventListener('pageshow', request);
    document.addEventListener('shopify:section:load', request);

    // Re-check after the facets re-render the results via the Section Rendering API.
    new MutationObserver(request).observe(document.documentElement, { childList: true, subtree: true });

    request();
  })();
  } catch(e) { console.error(e); }
})();

})();
